<script>
  import { nrkArrowDown } from '@nrk/core-icons'
  import { onMount } from 'svelte'
  export let bottomNavigation = false

  let visible = true
  onMount(() => {
    if (!bottomNavigation) {
      return
    }
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible = false
          }
        }
      },
      {
        threshold: 0,
        rootMargin: '100px 0px 100px 0px',
      },
    )
    const regions = document.querySelectorAll('[data-region="gaza"]')
    for (const region of regions) {
      observer.observe(region)
    }
  })

  function scrollToTop(e) {
    e.preventDefault()
    window?.scrollTo(0, 0)
    const h1 = document.querySelectorAll('h1')[0]
    h1?.focus({ preventScroll: true })
  }
</script>

{#if !bottomNavigation}
  <div class="links">
    <a href="#lokal"
      >Israel og Palestina <span class="icon" aria-hidden="true">{@html nrkArrowDown}</span></a
    >
    <a href="#regional"
      >Midtøsten <span class="icon" aria-hidden="true">{@html nrkArrowDown}</span></a
    >
    <a href="#global">Verden <span class="icon" aria-hidden="true">{@html nrkArrowDown}</span></a>
  </div>
{:else if bottomNavigation && visible}
  <p>
    <strong>Dette er en sak i tre deler. Gikk du glipp av noe? </strong>
  </p>
  <div class="links bottomnavigation">
    <a href="#lokal" on:click={scrollToTop}
      >Til toppen <span class="icon" aria-hidden="true">{@html nrkArrowDown}</span></a
    >
  </div>
{/if}

<style>
  .links {
    display: grid;
    grid-template-rows: repeat(auto-fit, 1fr);
    gap: 12px;
  }

  a {
    width: fit-content;
    line-height: 1.5;
    font-size: calc(19 / 16 * 1rem);
    border-radius: 100px;
    padding: 10px 20px;
    border: 1px solid var(--nrk-color-core-blue-50, #eef5ff);
    flex: 0 1 auto;
    display: inline-flex;
    align-items: center;
    color: #fff;
    text-decoration: none;
  }

  .icon {
    font-size: 0.9rem;
    position: relative;
    top: 2px;
    margin-left: 5px;
  }
  .bottomnavigation .icon {
    transform: rotate(180deg) translateY(5px) translateX(-5px);
  }

  [href='#lokal'] .icon {
    color: #ff7461;
  }
  [href='#regional'] .icon {
    color: #fec864;
  }
  [href='#global'] .icon {
    color: #6ac6ee;
  }
</style>
